export default __webpack_public_path__ + "static/media/checkfalse.6540ecdb.svg";